<template>
  <ul class="main-nav">
    <!-- <header-menu v-if="isUsuarioLogado"></header-menu> -->
    <li class="login-link" v-if="isUsuarioLogado">
      <router-link to="/caduceus/dashboard">Dashboard</router-link>
    </li>
    
    <li class="login-link" v-if="isStudent">
      <router-link to="/caduceus/profile">Meu Perfil</router-link>
    </li>
    <li class="login-link" v-if="isStudent">
      <router-link to="/caduceus/orders">Meus Pagamentos</router-link>
    </li>
    <li class="login-link" v-if="isStudent">
      <router-link to="/caduceus/subscriptions">Minhas Assinaturas</router-link>
    </li>
    <li class="login-link" v-if="isStudent">
      <router-link to="/caduceus/settings">Configurações</router-link>
    </li>
    <li class="login-link" v-if="isUsuarioLogado">
      <router-link to="/" @click="sair">Sair</router-link>
    </li>
    <li class="login-link" v-if="!isUsuarioLogado">
      <router-link to="/login">Login</router-link>
    </li>
    <li class="login-link" v-if="!isUsuarioLogado">
      <router-link to="/register">Criar Conta</router-link>
    </li>
    <!-- {{ isUsuarioLogado }} -->
  </ul>
</template>
<script setup>
import { JWTHandler } from '@/jwtHandler';
import { ref } from 'vue';
const isUsuarioLogado =  JWTHandler.isCurrentTokenValid();
const userData = ref(JWTHandler.getUserData());
const isAdmin = ref(isUsuarioLogado && JWTHandler.getUserData().isRole('ADMIN'));
const isInstructor = ref(isUsuarioLogado && JWTHandler.getUserData().isRole('INSTRUCTOR'));
const isStudent = ref(isUsuarioLogado && JWTHandler.getUserData().isRole('STUDENT'));

const sair = () => {

  JWTHandler.logout();
  window.location.href = '/';
}
</script>
